import React, { useState } from "react";
import { useSelector } from "react-redux";
import { LanguageLoader } from "../../assets/languages";

export const Step = ({children, className}) =>
{
	return <div className={className}>{children}</div>
}

const Stepper = ({children, onFinish, step=1}) =>
{
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const [currentStep, SetCurrentStep] = useState(step);
	const steps = children;
	const Backward = () =>
	{
		if(currentStep !== 1)
		{
			SetCurrentStep(currentStep-1);
		}
	}

	const Forward = () =>
	{
		const props = steps[currentStep-1].props;
		if(currentStep === steps.length && onFinish)
		{
			onFinish();
		}
		else if(props && props.onSubmit)
		{
			if(props.onSubmit() !== false)
			{
				if(currentStep < steps.length)
				{
					SetCurrentStep(currentStep+1);
				}
			}
		}
		else if(currentStep < steps.length)
		{
			SetCurrentStep(currentStep+1);
		}
	}
	return <div>
		<Step>{steps[currentStep-1]}</Step>
		<div className="flex justify-between mt-4">
			{currentStep !== 1 ? <button className="btn btn-secondary" onClick={Backward}>{language.PREV_STEP}</button> : <div></div>}
			{currentStep < steps.length ? <button className="btn btn-secondary" onClick={Forward}>{language.NEXT_STEP}</button> : <button className="btn" onClick={Forward}>{language.SAVE}</button>}
		</div>
	</div>
}
export default Stepper;